import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'sm-ui';

import messages from '../plannerMessages';

const ModalAddRow = ({ isOpen, direction, onClose, onConfirm }) => {
  let resolvedTitle = '';
  let resolvedMessage = '';
  if (direction === 'a') {
    resolvedTitle = <FormattedMessage {...messages.aAddRowTitle} />;
    resolvedMessage = <FormattedMessage {...messages.aAddRowMessage} />;
  }
  if (direction === 'b') {
    resolvedTitle = <FormattedMessage {...messages.bAddRowTitle} />;
    resolvedMessage = <FormattedMessage {...messages.bAddRowMessage} />;
  }

  return (
    <Modal
      show={isOpen}
      icon={'pe-7s-repeat'}
      onClose={onClose}
      title={resolvedTitle}
      message={resolvedMessage}
      buttons={[
        {
          id: 1,
          label: <FormattedMessage {...messages.cancel} />,
          onClick: () => onClose(),
        },
        {
          id: 2,
          label: <FormattedMessage {...messages.confirm} />,
          onClick: id => onConfirm(id),
        },
      ]}
    />
  );
};

export default ModalAddRow;
